import type { StoreApi } from "zustand";
import type { TChatStore } from "../chat-store.types";

type TSetState = StoreApi<TChatStore>["setState"];

export const createTabsActions = (set: TSetState) => ({
  setConversationTab: (value: number) =>
    set((state) => ({ tabs: { ...state.tabs, conversation: value } })),
});
